import {
  ReportScheduleResource,
  EmailSubscriptionMembershipResource,
  ReportSchedule,
  EmailMemberships,
} from '@mode/shared/schedules/contract';
import { getForm, getHref } from '@mode/shared/util-halogen';

export function toSchedule(schedule: ReportScheduleResource): ReportSchedule {
  const reportSubscriptions = schedule?._embedded?.['report_subscriptions']?._embedded?.['report_subscriptions']?.[0];
  const slackSubscriptions =
    reportSubscriptions?._embedded?.slack_subscription_memberships?._embedded?.slack_subscription_memberships ?? [];
  const editForm = getForm(schedule, 'edit');
  const cron = <any>editForm?.input?.['report_schedule']['cron'];
  const reportSubscriptionsForm =
    reportSubscriptions?.csv_attachments_enabled !== undefined ? getForm(reportSubscriptions, 'edit') : null;
  const emailMemberships = reportSubscriptions
    ? formatEmailMemberships(reportSubscriptions?._embedded?.email_subscription_memberships?.[0])
    : undefined;

  return {
    id: schedule.token,
    cron: cron,
    dayOfMonth: schedule.day_of_month,
    dayOfWeek: schedule.day_of_week,
    frequency: schedule.frequency,
    hour: cron.hour.value,
    lastScheduledRun: schedule.last_scheduled_run,
    minute: cron.minute.value,
    name: schedule.name || 'Untitled schedule',
    paused: schedule.paused,
    parameters: schedule.parameters,
    paramsMetaData: editForm?.input?.['report_schedule']['params'],
    reportName: schedule.report_name || 'Untitled',
    reportToken: schedule.report_token,
    reportType: schedule.report_type,
    subscribed: schedule.subscribed,
    subscriberCount: schedule.subscriber_count,
    timeZone: schedule.time_zone,
    token: schedule.token,
    canDeleteSchedule: !!getForm(schedule, 'destroy'),
    canEditSchedule: !!editForm,
    delivery: schedule?.delivery ?? null,
    hasSubscription: reportSubscriptions !== undefined,
    hasSlackSubscription: slackSubscriptions?.length > 0,
    hasUpdates: false,
    emailMemberships: emailMemberships,
    subscription:
      reportSubscriptions !== undefined
        ? {
            id: reportSubscriptions ? getHref(reportSubscriptions, 'self') : null,
            csvAttachmentsEnabled: reportSubscriptions?.csv_attachments_enabled,
            dataPreviewsEnabled: reportSubscriptions?.data_previews_enabled,
            dataTablesEnabled: reportSubscriptions?.data_tables_enabled,
            pdfAttachmentsEnabled: reportSubscriptions?.pdf_attachments_enabled,
            reportLinksEnabled: reportSubscriptions?.report_links_enabled,
            createEmailSubscriptionUrl: reportSubscriptions
              ? `${getHref(reportSubscriptions, 'self')}/email_memberships`
              : null,
            _formElements: reportSubscriptionsForm?.input?.['report_subscription'],
            slackSubscription: {
              channel: slackSubscriptions[0]?.channel,
              channelId: slackSubscriptions[0]?.channel_id,
              channelType: slackSubscriptions[0]?.channel_type,
            },
          }
        : null,
  };
}

function formatEmailMemberships(emailMemberships: EmailSubscriptionMembershipResource) {
  let formattedEmailMemberships: EmailMemberships | undefined = undefined;
  if (emailMemberships) {
    const destroyForm = getForm(emailMemberships, 'destroy');
    formattedEmailMemberships = {
      id:
        getHref(emailMemberships, 'report_subscription') ??
        'Link to subscription url was not provided from the endpoint',
      email: emailMemberships.email,
      deleteUrl: <string>destroyForm?.action,
    };
  }
  return formattedEmailMemberships;
}
